var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ja-chart-wrap']},[_c('h2',[_vm._v(_vm._s(_vm.titleText)+" "),_c('small',[_vm._t("btn")],2)]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }